import { combineReducers } from "redux";

// Front
import LayoutReducer from "./layouts/reducer";
import LanguageReducer from "./language/reducer";

// Authentication
import LoginReducer from "./auth/login/reducer";
import ProfileReducer from "./auth/profile/reducer";
import AppSettingsReducer from "./appSettings/reducer";

// KDashboard
import KDashboardReducer from "./kdashboard/reducer";

import FAQReducer from "./faq/reducer";
import PromptsReducer from "./prompts/reducer";

const rootReducer = combineReducers({
    Layout: LayoutReducer,
    Language: LanguageReducer,
    Login: LoginReducer,
    AppSettings: AppSettingsReducer,
    Profile: ProfileReducer,
    KDashboard: KDashboardReducer,
    FAQ: FAQReducer,
    Prompts: PromptsReducer,
});

export default rootReducer;